import React, { useState } from "react";
import { Grid, Skeleton } from "@mui/material";

export const ChatBox = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Grid
      container
      item
      direction="column"
      alignItems="center"
      sx={{ flex: 1, padding: 2 }}
    >
      {isLoading && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="30%"
          sx={{ position: "absolute", top: "35%" }}
        />
      )}

      <iframe
        src="https://www.chatbase.co/chatbot-iframe/5w_-nIWhDdEIdpq1LwAzh"
        onLoad={() => setIsLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Alga AI Chat"
      />
    </Grid>
  );
};
